import { Status } from "@helper/abstraction/status";
import { DocumentsParams, DocumentState, DocumentType, DocType, EdocumentType } from "@helper/abstraction/documents";

export interface DocumentsFilterConstructorParams {
	documentTypeId: DocumentType;
	documentState: DocumentState;
	page?: number;
	size?: number;
	documentDateEnd?: Date;
	documentDateStart?: Date;
	processingStatusList?: Status[];
	documentNumber?: string;
	edocumentNumber?: string;
	partner?: Status;
	storage?: Status;
	documentType?: DocType;
	formType?: DocType;
	documentDirection?: DocType;
	useDocumentDate?: string;
	edocumentType?: EdocumentType;
	fileName?: string;
	deliveryNoteNumber?: string;
	deliverySystemType?: DocType;
	dateCreateFrom?: Date;
	dateCreateTo?: Date;
	dateExpireFrom?: Date;
	dateExpireTo?: Date;
	routeStatus?: Status[];
}

export class DocumentsFilter implements DocumentsParams {
	public documentTypeId: DocumentType;
	public documentState: DocumentState; // Состояние документа: Черновик, Входящие, Исходящие

	public page: number;
	public size: number;
	public documentDateEnd: Date;
	public documentDateStart: Date;

	public dateCreateFrom: Date | undefined;
	public dateCreateTo: Date | undefined;
	public dateExpireFrom: Date | undefined;
	public dateExpireTo: Date | undefined;
	public routeStatus?: Status[];

	public processingStatusList?: Status[];
	public documentNumber?: string;
	public edocumentNumber?: string;
	public partner?: Status;
	public storage?: Status;
	public documentType?: DocType;
	public formType?: DocType;
	public documentDirection?: DocType;
	public useDocumentDate?: string;
	public edocumentType?: EdocumentType;
	public fileName?: string;
	public deliveryNoteNumber?: string;
	public deliverySystemType?: DocType;
	private createAt?: Date;

	constructor(filter: DocumentsFilterConstructorParams) {
		this.createAt = new Date();
		this.documentTypeId = filter.documentTypeId;
		this.documentState = filter.documentState;
		this.page = filter.page || 1;
		this.size = filter.size || 50;
		this.documentDateEnd = filter.documentDateEnd || new Date(this.createAt.getFullYear(), this.createAt.getMonth(), this.createAt.getDate(), 23, 59, 59, 59);
		this.documentDateStart = filter.documentDateStart || new Date(this.createAt.getFullYear(), this.createAt.getMonth() - 1, this.createAt.getDate(), 0, 0, 0, 0);
		this.processingStatusList = filter.processingStatusList;
		this.documentNumber = filter.documentNumber;
		this.edocumentNumber = filter.edocumentNumber;
		this.partner = filter.partner;
		this.storage = filter.storage;
		this.documentType = filter.documentType;
		this.formType = filter.formType;
		this.documentDirection = filter.documentDirection;
		this.useDocumentDate = filter.useDocumentDate;
		this.edocumentType = filter.edocumentType;
		this.fileName = filter.fileName;
		this.deliveryNoteNumber = filter.deliveryNoteNumber;
		this.deliverySystemType = filter.deliverySystemType;
		this.dateCreateFrom = filter.dateCreateFrom;
		this.dateCreateTo = filter.dateCreateTo;
		this.dateExpireFrom = filter.dateExpireFrom;
		this.dateExpireTo = filter.dateExpireTo;
		this.routeStatus = filter.routeStatus;
	}
}
